import type { ReactNode } from 'react'
import SiteNav from '@/components/organisms/SiteNav'
import FooterStub from '@/components/organisms/FooterStub'

interface LegalPageLayoutProps {
    title: string;
    draftNotice?: string;
    effectiveDate: string;
    lastUpdated: string;
    children: ReactNode;
}

// Shared layout for dated website policies and statements.
export function LegalPageLayout({ title, draftNotice, effectiveDate, lastUpdated, children }: LegalPageLayoutProps) {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />

                <section className="pt-section-gap">
                    <h1 className="max-w-2xl text-4xl font-medium text-unimo-slate lg:text-5xl">{title}</h1>

                    {draftNotice && (
                        <div className="mt-6 max-w-2xl rounded-site-card border-[3px] border-unimo-site-grey-300 bg-white p-4 text-sm font-light text-unimo-slate">
                            {draftNotice}
                        </div>
                    )}

                    <p className="mt-4 text-sm font-light text-unimo-site-grey-700">
                        Effective date: {effectiveDate}
                        <br />
                        Last updated: {lastUpdated}
                    </p>
                </section>

                <section className="max-w-2xl pb-section-gap pt-section-headline-gap-top">
                    {children}
                </section>

                <FooterStub />
            </div>

        </div>
    )
}

export default LegalPageLayout
